import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit } from '@angular/core';

import { BreadcrumbComponent } from '../../../shared/components/breadcrumb/breadcrumb.component';
import { IBreadcrumb } from '../../../utils/interfaces/breadcrumb';

import { ActivatedRoute } from '@angular/router';
import * as L from 'leaflet';
import { TableComponent } from '../../../shared/components/table/table.component';
import { IHomeDetails } from '../../../utils/interfaces/home';
import { ITableHeader } from '../../../utils/interfaces/table-header';

@Component({
  selector: 'app-device-details',
  standalone: true,
  imports: [CommonModule, BreadcrumbComponent, TableComponent],
  templateUrl: './device-details.component.html',
  styleUrl: './device-details.component.scss',
})
export class DeviceDetailsComponent implements OnInit, AfterViewInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  breadcrumb: IBreadcrumb[] = [];

  private map!: L.Map;
  markers: L.Marker[] = [];

  tableHeader: ITableHeader[] = [
    'Dispositivos,device',
    'Cliente,customerName',
    'Última atualização,lastConnection',
    'Pesquisa atual,currentPoll',
    'Data de ativação,activationDate',
  ].map((item) => {
    const [description, propertyKey] = item.split(',');

    return {
      description: description,
      propertyKey: propertyKey ?? '',
      status: propertyKey === 'status',
      date: ['lastConnection', 'activationDate'].includes(propertyKey),
      showHour: propertyKey === 'lastConnection',
      actions: false,
      filter: false,
    };
  });

  shiftTableHeader: ITableHeader[] = [
    'Turnos,description',
    'Horário início,startTime',
    'Horário final,endTime',
  ].map((item) => {
    const [description, propertyKey] = item.split(',');

    return {
      description: description,
      propertyKey: propertyKey ?? '',
      status: false,
      date: false,
      showHour: false,
      actions: false,
      filter: false,
    };
  });

  emailsTableHeader: ITableHeader[] = [
    'Diário,day',
    'Semanal,week',
    'Mensal,month',
    'Nome,name',
    'Email,email',
  ].map((item) => {
    const [description, propertyKey] = item.split(',');

    return {
      description: description,
      propertyKey: propertyKey ?? '',
      status: false,
      date: false,
      showHour: false,
      actions: false,
      filter: false,
    };
  });

  homeDetails!: IHomeDetails;

  ngOnInit(): void {
    this.homeDetails = this.activatedRoute.snapshot.data['details']
      .data as IHomeDetails;

    this.breadcrumb = [
      {
        description: 'Dispositivos',
        url: 'main/home',
        askBeforeChangingRoute: true,
        textTitle: 'Dispositivos',
        descriptionMsg: 'Voltar para a lista de dispositivos?',
      },
      {
        description: `Detalhe ${this.homeDetails.deviceName}`,
        url: '',
      },
    ];
  }

  ngAfterViewInit(): void {
    this.initMap();
    this.addMarker(+this.homeDetails.latitude, +this.homeDetails.longitude);
    this.centerMap();
  }

  private initMap() {
    const baseMapURl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    this.map = L.map('map').setView(
      [+this.homeDetails.latitude, +this.homeDetails.longitude],
      13
    );
    L.tileLayer(baseMapURl).addTo(this.map);
  }

  private addMarker(lat: number, lng: number) {
    const customIcon = L.icon({
      iconUrl: 'assets/img/location.png', // URL de um ícone personalizado
      iconSize: [32, 32], // Tamanho do ícone
      iconAnchor: [16, 32], // Ponto onde o ícone estará ancorado
    });

    const marker = L.marker([lat, lng], { icon: customIcon }).addTo(this.map);
    this.markers.push(marker);
  }

  private centerMap() {
    if (this.markers.length > 0) {
      const bounds = L.latLngBounds(
        this.markers.map((marker) => marker.getLatLng())
      );
      this.map.fitBounds(bounds);
    }
  }
}
